import styled from "styled-components";
import { ProgressBar } from "./ProgressBar";
import { Percent } from "./styles";

interface Props {
  aisleKey: string;
  aisle: any;
}

const PalletBox = styled.div<{ $status: number }>`
  width: 16px;
  height: 16px;
  border: 1px solid #333;
  border-radius: 2px;
  background-color: ${(props) => {
    switch (props.$status) {
      case 1:
        return "#D90429"; // Zajęte (Czerwony)
      case 2:
        return "#808080"; // Stan 0 szt (Szary)
      case 3:
        return "#FFA500"; // Niepełny EAN (Pomarańczowy)
      case 0:
      default:
        return "#439E46"; // Wolne (Zielony)
    }
  }};
`;

const RowContainer = styled.div`
  display: flex;
  gap: 2px;
`;

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
`;

export const AisleRow = ({ aisleKey, aisle }: Props) => {
  const occupancyPercent = ((aisle.occupied / aisle.totalSpaces) * 100).toFixed(1);
  const freePercent = ((aisle.free / aisle.totalSpaces) * 100).toFixed(1);

  return (
    <>
      <tr key={aisleKey}>
        <td>{aisleKey}</td>
        <td>
          {aisle.occupied} / {aisle.totalSpaces}
          <Percent>
            ({occupancyPercent}%)
            <br />
            <ProgressBar occupied={aisle.occupied} total={aisle.totalSpaces} />
          </Percent>
        </td>
        <td>
          {aisle.free} <Percent>({freePercent}%)</Percent>
        </td>
      </tr>
      <tr>
        <td colSpan={3}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              maxWidth: "380px",
              margin: "10px auto"
            }}
          >
            {Object.entries(aisle.shelfs).map(([shelfId, grid]: [string, any]) => {
              const shelfGrid = grid as number[][];
              return (
                <GridContainer key={shelfId}>
                  <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>{shelfId}</div>
                  {shelfGrid.map((row, rowIndex) => (
                    <RowContainer key={rowIndex}>
                      {row.map((status, colIndex) => (
                        <PalletBox key={colIndex} $status={status} />
                      ))}
                    </RowContainer>
                  ))}
                </GridContainer>
              );
            })}
          </div>
        </td>
      </tr>
    </>
  );
};
